import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListEnglishIqHistoryV2Response } from './list-english-iq-history-v2-response';
import { listEnglishIqHistoryV2ResponseSchema } from './list-english-iq-history-v2-response';

export async function listEnglishIqHistoryV2Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListEnglishIqHistoryV2Response>> {
  return getRequest<IListEnglishIqHistoryV2Response>({
    options,
    path: '/english-iq/history/v2',
    schema: listEnglishIqHistoryV2ResponseSchema,
  });
}
